import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaClock,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaPaperPlane
} from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [result, setResult] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResult("Sending...");

    const formDataToSend = new FormData();
    formDataToSend.append("access_key", "55404875-0dd0-468b-ab6d-655f3c2436b5");
    formDataToSend.append("name", formData.name);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("phone", formData.phone);
    formDataToSend.append("subject", formData.subject);
    formDataToSend.append("message", formData.message);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formDataToSend
      });

      const data = await response.json();

      if (data.success) {
        setSubmitted(true);
        setResult("Your message has been sent successfully!");

        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });

        setTimeout(() => setSubmitted(false), 5000);
      } else {
        setResult("Something went wrong. Please try again.");
      }
    } catch (error) {
      setResult("Network error. Please try later.");
    }
  };

  const contactInfo = [
    {
      icon: <FaMapMarkerAlt />,
      title: 'Visit Us',
      details: ['Sector 7, Sonipat, Haryana 131021']
    },
    {
      icon: <FaPhone />,
      title: 'Call Us',
      details: ['+91 9896251565']
    },
    {
      icon: <FaEnvelope />,
      title: 'Email Us',
      details: ['info@nnbsportsclub.com']
    },
    {
      icon: <FaClock />,
      title: 'Opening Hours',
      details: ['Mon - Sat: 6:00 AM - 10:00 PM', 'Sunday: 7:00 AM - 8:00 PM']
    }
  ];

  const subjects = [
    'General Inquiry',
    'Membership Information',
    'Court Booking',
    'Training Programs',
    'Events & Tournaments',
    'Corporate Booking',
    'Feedback/Suggestion',
    'Other'
  ];

  return (
    <div className="contact-page">

      {/* Page Header */}
      <section className="page-header">
        <div className="page-header-overlay"></div>
        <div className="container">
          <div className="page-header-content">
            <span className="page-badge">Contact Us</span>
            <h1>Get in Touch</h1>
            <p>We'd love to hear from you. Reach out with any questions or inquiries.</p>
            <nav className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Contact</span>
            </nav>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="contact-info-section">
        <div className="container">
          <div className="contact-info-grid">
            {contactInfo.map((info, index) => (
              <div className="contact-info-card" key={index}>
                <div className="contact-icon">{info.icon}</div>
                <h3>{info.title}</h3>
                {info.details.map((detail, idx) => (
                  <p key={idx}>{detail}</p>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="contact-form-section section">
        <div className="container">
          <div className="contact-grid">

            <div className="contact-form-wrapper">
              <div className="form-header">
                <span className="section-badge">Send a Message</span>
                <h2>Contact Form</h2>
                <p>Fill out the form below and we'll get back to you within 24 hours.</p>
              </div>

              {submitted && (
                <div className="success-message">
                  ✓ Thank you! Your message has been sent successfully.
                </div>
              )}

              {result && <p className="form-result">{result}</p>}

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required />
                  </div>

                  <div className="form-group">
                    <label>Email *</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} required />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Phone</label>
                    <input type="tel" name="phone" value={formData.phone} onChange={handleChange} />
                  </div>

                  <div className="form-group">
                    <label>Subject *</label>
                    <select name="subject" value={formData.subject} onChange={handleChange} required>
                      <option value="">Select Subject</option>
                      {subjects.map((s, i) => (
                        <option key={i} value={s}>{s}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label>Message *</label>
                  <textarea name="message" rows="6" value={formData.message} onChange={handleChange} required />
                </div>

                <button type="submit" className="btn btn-primary btn-lg">
                  <FaPaperPlane /> Send Message
                </button>
              </form>
            </div>

            {/* Sidebar */}
            <div className="contact-sidebar">
              <div className="social-box">
                <h3>Follow Us</h3>
                <p>Stay connected with Net Nest on social media</p>
                <div className="social-links-large">
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="facebook">
                    <FaFacebookF /> Facebook
                  </a>
                  <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="twitter">
                    <FaTwitter /> Twitter
                  </a>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="instagram">
                    <FaInstagram /> Instagram
                  </a>
                  <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="youtube">
                    <FaYoutube /> YouTube
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
